import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Produtos from './pages/Produtos';
import ProductForm from './pages/ProductForm';
import Pedidos from './pages/Pedidos';
import OrderDetails from './pages/OrderDetails';
import Categorias from './pages/Categorias';
import Promocoes from './pages/Promocoes';
import MobilePushInitializer from '@/shared/components/MobilePushInitializer';
import KeepAliveInitializer from '@/shared/components/KeepAliveInitializer';

function AdminApp() {
  return (
    <AdminLayout>
      {/* Inicializar sistema de notificações push mobile também no admin (para quando for mobile) */}
      <MobilePushInitializer />
      {/* Inicializar sistema de keep-alive para manter o servidor ativo (especialmente importante para PWA/APK) */}
      <KeepAliveInitializer />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/produtos" element={<Produtos />} />
        <Route path="/pedidos" element={<Pedidos />} />
        <Route path="/pedidos/:id" element={<OrderDetails />} />
        <Route path="/categorias" element={<Categorias />} />
        <Route path="/promocoes" element={<Promocoes />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
}

export default AdminApp;

